// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__NxOb2","header":"PatientBlock_header__v7Lgr","label":"PatientBlock_label__2wujU","option":"PatientBlock_option__2CBDg"};